import React, { useState, useContext } from "react";
import { Button, CircularProgress } from "@material-ui/core";

import { Context as AuthContext } from "../context/auth.context";
import { Context as PortalContext } from "../context/portal.context";

const ForgotPassword = (props) => {
  const [username, setUsername] = useState("");
  const [view, setView] = useState("forgotPassword");
  const [resetCode, setResetCode] = useState("");
  const [newPassword, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const { forgotPassword, validatePasswordCode, setNewPassword } = useContext(
    AuthContext
  );
  const { state } = useContext(PortalContext);

  function checkPasswords() {
    if (
      newPassword.replace(/[^A-Z]/g, "").length < 1 ||
      newPassword.length < 8
    ) {
      return true;
    } else {
      if (newPassword === confirmPassword) {
        return false;
      } else {
        return true;
      }
    }
  }

  if (view === "forgotPassword") {
    return (
      <>
        <div>
          <label
            style={{
              color: "#2f343b",

              display: "flex",
              alignSelf: "flex-start",
              marginBottom: 8,
              marginTop: 25,
            }}
          >
            <x-lang>Username</x-lang>
          </label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            id="intellipay-username-forgot-password"
            style={{
              height: 40,
              width: 300,
              borderRadius: 6,
              border: "1px solid #d3dce0",
              boxShadow: "inset 0px 0px 0px 0px",
              outline: "none",
              borderStyle: "solid",
              paddingLeft: 8,
              paddingRight: 8,
              fontSize: "1rem",
              fontWeight: 400,
              marginBottom: 25,
            }}
          />
        </div>
        {errorMessage ? (
          <span style={{ color: "red" }}>{errorMessage}</span>
        ) : null}
        <Button
          variant="contained"
          color="primary"
          disableElevation
          onClick={async () => {
            setLoading(true);
            let response = await forgotPassword({
              username,
              merchantID: state.merchantID,
            });
            if (response === 1) {
              setView("validateCode");
              setErrorMessage(null);
            } else {
              setErrorMessage("Invalid username");
            }

            setLoading(false);
          }}
          style={{
            width: 200,
            height: 40,
            borderRadius: 25,
            color: "white",
            marginTop: 25,
          }}
        >
          {loading ? (
            <CircularProgress
              style={{ color: "white", fontSize: 16 }}
              size={16}
            />
          ) : (
            "Send Code"
          )}
        </Button>
        <div style={styles.noAccountBox}>
          <Button
            onClick={() => props.setView("login")}
            style={{ color: "#1C9BDD" }}
          >
            <x-lang>Back to login</x-lang>
          </Button>
        </div>
      </>
    );
  } else if (view === "validateCode") {
    return (
      <>
        <div>
          <label
            style={{
              color: "#2f343b",

              display: "flex",
              alignSelf: "flex-start",
              marginBottom: 8,
              marginTop: 25,
            }}
          >
            <x-lang>Enter Reset Code</x-lang>
          </label>
          <input
            type="text"
            value={resetCode}
            onChange={(e) => setResetCode(e.target.value)}
            id="intellipay-resetCode-forgot-password"
            style={{
              height: 40,
              width: 300,
              borderRadius: 6,
              border: "1px solid #d3dce0",
              boxShadow: "inset 0px 0px 0px 0px",
              outline: "none",
              borderStyle: "solid",
              paddingLeft: 8,
              paddingRight: 8,
              fontSize: "1rem",
              fontWeight: 400,
              marginBottom: 25,
            }}
          />
        </div>
        {errorMessage ? (
          <span style={{ color: "red" }}>{errorMessage}</span>
        ) : null}
        <div style={styles.noAccountBox}>
          <span><x-lang>Didn't receive email?</x-lang></span>
          <Button
            onClick={async () => {
              setLoading(true);
              let response = await forgotPassword({
                username,
                merchantID: state.merchantID,
              });
              if (response === 1) {
                setView("validateCode");
              }

              setLoading(false);
            }}
            style={{ color: "#1C9BDD" }}
          >
            <x-lang>Resend Code</x-lang>
          </Button>
        </div>
        <Button
          variant="contained"
          color="primary"
          disableElevation
          onClick={async () => {
            setLoading(true);
            let response = await validatePasswordCode({
              resetCode,
            });
            if (response === 1) {
              setView("enterNewPassword");
              setErrorMessage(null);
            } else {
              setErrorMessage("Cannot validate reset code");
            }

            setLoading(false);
          }}
          style={{
            width: 200,
            height: 40,
            borderRadius: 25,
            color: "white",
            marginTop: 25,
          }}
        >
          {loading ? (
            <CircularProgress
              style={{ color: "white", fontSize: 16 }}
              size={16}
            />
          ) : (
            "Verify Code"
          )}
        </Button>
        <div style={styles.noAccountBox}>
          <Button
            onClick={() => props.setView("login")}
            style={{ color: "#1C9BDD" }}
          >
            <x-lang>Back to login</x-lang>
          </Button>
        </div>
      </>
    );
  } else if (view === "enterNewPassword") {
    return (
      <>
        <div>
          <label
            style={{
              color: "#2f343b",

              display: "flex",
              alignSelf: "flex-start",
              marginBottom: 8,
              marginTop: 25,
            }}
          >
            <x-lang>New Password</x-lang>
          </label>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setPassword(e.target.value)}
            id="intellipay-newpassword-forgot-password"
            style={{
              height: 40,
              width: 300,
              borderRadius: 6,
              border: "1px solid #d3dce0",
              boxShadow: "inset 0px 0px 0px 0px",
              outline: "none",
              borderStyle: "solid",
              paddingLeft: 8,
              paddingRight: 8,
              fontSize: "1rem",
              fontWeight: 400,
              marginBottom: 10,
            }}
          />

          <label
            style={{
              color: "#2f343b",

              display: "flex",
              alignSelf: "flex-start",
              marginBottom: 8,
              marginTop: 10,
            }}
          >
            <x-lang>Confirm New Password</x-lang>
          </label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            id="intellipay-confirm-forgot-password"
            style={{
              height: 40,
              width: 300,
              borderRadius: 6,
              border: "1px solid #d3dce0",
              boxShadow: "inset 0px 0px 0px 0px",
              outline: "none",
              borderStyle: "solid",
              paddingLeft: 8,
              paddingRight: 8,
              fontSize: "1rem",
              fontWeight: 400,
              marginBottom: 25,
            }}
          />
        </div>
        <span style={{ marginBottom: 10, color: "grey" }}>
        <x-lang>Must be at least 8 characters</x-lang>
        </span>
        <span style={{ marginBottom: 10, color: "grey" }}>
        <x-lang>Must have at least one uppercase letter</x-lang>
        </span>
        {errorMessage ? (
          <span style={{ color: "red" }}>{errorMessage}</span>
        ) : null}
        <Button
          variant="contained"
          color="primary"
          disableElevation
          disabled={checkPasswords()}
          onClick={async () => {
            setLoading(true);
            let response = await setNewPassword({
              password: newPassword,
              confirmPassword,
            });
            if (response === 1) {
              setView("forgotPassword");
              setErrorMessage(null);
              props.setView("login");
            } else {
              setErrorMessage(response.message);
            }

            setLoading(false);
          }}
          style={{
            width: 200,
            height: 40,
            borderRadius: 25,
            color: "white",
            marginTop: 25,
          }}
        >
          {loading ? (
            <CircularProgress
              style={{ color: "white", fontSize: 16 }}
              size={16}
            />
          ) : (
            "Save"
          )}
        </Button>
        <div style={styles.noAccountBox}>
          <Button
            onClick={() => props.setView("login")}
            style={{ color: "#1C9BDD" }}
          >
            <x-lang>Back to login</x-lang>
          </Button>
        </div>
      </>
    );
  }
};

const styles = {
  noAccountBox: {
    width: "100%",
    marginTop: 15,
    textAlign: "center",
    boxSizing: "border-box",
    cursor: "pointer",
  },
};

export default ForgotPassword;
